<template>
	<div class="d-flex flex-column">		
		<git-config-importer v-for="item in results" :key="item.name" :data="item"/>
	</div>
</template>

<script>


import GitConfigImporter from './GitConfigImporter'

export default {
	name: "ImportEverything",
	components: {
		GitConfigImporter
	},
	props: {
        results: Array,
		git: Object
    },
	methods: {
		close() {
			this.$refs.gitImportEverythingModal.hide();	
		}
	}
};
</script>

<style scoped>
</style>